import { useTranslation } from "react-i18next";

const FieldReview = ({ label, value, source, mode }) => {
    const { t } = useTranslation();

    const labelClass =
        source === "new"
            ? "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200"
            : "bg-gray-100 text-gray-700 dark:bg-gray-800/70 dark:text-gray-200";

    return (
        <div className="grid grid-cols-[120px_1fr] gap-2 text-sm mb-1 items-center text-gray-800 dark:text-gray-200">
            <span className="font-medium">{label}:</span>
            <span className="flex items-center gap-2">
                <span className="text-gray-700 dark:text-gray-100">{value || "-"}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${labelClass}`}>
                    {mode === "manual-parent-merge"
                      ? source === "new"
                        ? t("parentMerge.parentB", { defaultValue: "Parent B" })
                        : t("parentMerge.parentA", { defaultValue: "Parent A" })
                      : t(`applications.label.${source}`, source === "new" ? "New" : "Existing")}
                </span>
            </span>
        </div>
    );
};

const ParentReview = ({ title, parent, choices, mode }) => (
    <div className="mb-6 rounded-xl border border-gray-200 bg-white/90 p-3 shadow-sm dark:border-gray-700 dark:bg-gray-900/80">
        <h3 className="text-md font-semibold mb-2 text-gray-900 dark:text-gray-100">{title}</h3>
        {Object.entries(parent || {}).map(([field, value]) => {
            const source = choices[field] || "existing";
            return (
                <FieldReview
                    key={field}
                    label={field}
                    value={value || "-"}
                    source={source}
                    mode={mode}
                />
            );
        })}
    </div>
);

const ReviewStep = ({ parent1, parent1Choices, parent2, parent2Choices, children, mode = "application-conflict" }) => {
    const { t } = useTranslation();

    return (
        <div>
            <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100">
                {t("applications.review_choices", "Review your choices")}
            </h3>

            {parent1 && (
                <ParentReview
                    title={mode === "manual-parent-merge"
                        ? t("parentMerge.result", { defaultValue: "Merged parent" })
                        : t("applications.parent_1", "Parent 1")}
                    parent={parent1}
                    choices={parent1Choices}
                    mode={mode}
                />
            )}
            {parent2 && <ParentReview title={t("applications.parent_2", "Parent 2")} parent={parent2} choices={parent2Choices} mode={mode} />}

            {mode === "application-conflict" && <div className="mt-4">
                <h3 className="text-md font-semibold mb-2 text-gray-900 dark:text-gray-100">
                    {t("applications.children", "Child(ren)")}
                </h3>
                {children.length === 0 ? (
                    <p className="text-sm text-gray-500 dark:text-gray-300">
                        {t("applications.no_children_selected", "No children selected")}
                    </p>
                ) : (
                    <ul className="text-sm list-disc pl-5 text-gray-800 dark:text-gray-100">
                        {children.map((c, i) => (
                            <li key={i}>
                                {c.firstName} {c.lastName}
                                <span className="ml-2 text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full dark:bg-green-900/40 dark:text-green-200">
                                    {t("applications.label.new", "New")}
                                </span>
                            </li>
                        ))}
                    </ul>
                )}
            </div>}
        </div>
    );
};

export default ReviewStep;
